import GetCommentsByWorkItemIdRequestModelBase from '../_generated/modelBases/get-comments-by-work-item-id-request-model-base';

export default class GetCommentsByWorkItemIdRequestModel extends GetCommentsByWorkItemIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
